<template>
  <b-toast
    header-class="custom-toast-header"
    :toast-class="[type === 'info-green' ? 'map-toast' : '', 'custom-toast']"
    :id="toastId"
    solid
    no-close-button
    :auto-hide-delay="autoHideDelay"
    :type="type"
    :static="type === 'info-green'"
    :toaster="'b-toaster-bottom-center'"
    :no-auto-hide="noAutoHide"
  >
    <div class="body-wrapper">
      <button v-if="noAutoHide" class="news-close-button custom-toast-close" @click="$emit('onCloseClick', toastId)" />
      <img src="../../files/info-icon-green.svg" alt="info icon" v-if="type === 'info-green'" />
      <img src="../../files/info-icon-orange.svg" alt="info icon" v-if="type === 'info'" />
      <div class="content-wrapper">
        <h2 class="content-wrapper__title">{{ title }}</h2>
        <main-text>{{ content }}</main-text>
      </div>
    </div>
  </b-toast>
</template>

<script>
import MainText from "./Text.vue";
export default {
  components: { MainText },
  props: {
    toastId: {
      type: [String, Number],
      require: true,
    },
    content: {
      type: [String, Number],
      require: true,
    },
    title: {
      type: [String, Number],
      require: true,
    },
    autoHideDelay: {
      type: Number,
      default: 10000,
    },
    type: {
      type: String,
      default: "info",
    },
    noAutoHide: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.content-wrapper {
  display: flex;
  flex-direction: column;
}
.body-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.custom-toast {
  position: relative;
  min-height: 64px;
  border-radius: 6px;
  background: var(--white-color);
  box-shadow: 0px 2px 10px 0px rgba(5, 6, 36, 0.1), 0px 15px 40px 0px rgba(5, 6, 36, 0.15);
}

.map-toast {
  width: 538px;
  max-width: none;
}

.content-wrapper__title {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
  font-family: "Inter", sans-serif;
  color: var(--black-color);
}

.custom-toast-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px 0 16px;
  border: none;
}
.custom-toast-close {
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>
